import { capitalize } from 'es-toolkit';

export const padZero = (value: number) => (value < 10 ? `0${value}` : value.toString());

export const formatSecondsHHMMSS = (currentTimeInSeconds: number) => {
  const totalMinutes = Math.floor(currentTimeInSeconds / 60);
  const hours = padZero(Math.floor(totalMinutes / 60));
  const minutes = padZero(Math.floor(totalMinutes % 60));
  const seconds = padZero(Math.floor(currentTimeInSeconds % 60));

  return `${hours}:${minutes}:${seconds}`;
};

/**
 * Formats an enum value by converting underscores to spaces and capitalizing each word.
 *
 * @param value - The enum value string to format (e.g., "LOCAL_OUT_OF_MARKET")
 * @returns The formatted string with proper capitalization and spacing (e.g., "Local Out Of Market")
 *
 * @example
 * ```typescript
 * formatEnumValue("LOCAL_OUT_OF_MARKET") // Returns "Local Out Of Market"
 * formatEnumValue("USER_ADMIN") // Returns "User Admin"
 * ```
 */
// Replace with start case and then exclude words like MLB to preserve case
export const formatEnumValue = (value: string) => {
  return value.split('_').map(capitalize).join(' ');
};
